<template>
  <div class="container mt-4 bg-white rounded p-3 mb-2" dir="rtl">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <h3>{{name_route}}</h3>
          </div>
          <div class="d-flex">
            <div class="col-lg-12 mb-3">
              <label class="form-label">جملات</label>
              <textarea v-model="text" name="" class="form-control" id="" cols="30" rows="10"></textarea>
            </div>

          </div>
          <div class="d-flex align-items-center justify-content-center">
            <button v-if="is_update" @click.prevent="update(id_item)" class="btn btn-primary btn-submit-1">بروزرسانی</button>
            <Reset v-if="is_update" @click.prevent="reset" style="width: 2vw; height: 2vw;" class="mx-2" />
            <button v-else @click.prevent="store" class="btn btn-primary btn-submit-1">ذخیره</button>

          </div>
        </div>
        <hr class="mt-2 mb-2">
        <table v-if="all_items.length" class="table">
          <thead>
          <tr >
            <th style="width: 1vw;">ردیف</th>
            <th >عنوان مولفه</th>
            <th>شرح ویژگی در سازمان</th>
            <th style="width: 5vw">عملیات</th>
          </tr>
          </thead>
          <tr v-for="(item,index) in all_items">
            <td>{{index+1}}</td>
            <td>{{item.type}}</td>
            <td>{{item.text}}</td>
            <td>
              <div class="d-flex" style="height: 2.3vw;">
                <p style="width: 2vw;" @click.prevent="deleteMethod(item.id)" href="#"><img class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"> </p>
                <p  style="width: 2vw; " @click.prevent="edit(item.id, item.text)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></p>
              </div>
            </td>
          </tr>
        </table>
        <center v-else>
          <p>موردی یافت نشد!</p>
        </center>



      </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="submit_delete(id_item)">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";

const toast = useToast();

export default {
  name: 'HomeView',
  props: {
    type: {
      type: Number,
      required: true
    }
  },
  components: {
    Reset,
    Sidebar,
    splash
  },
  data() {
    return {
      id_route: this.type,
      name_route: '',
      text: '',
      all_items: [],
      id_item: '',
      is_update: false,
      deleteModal: false,

    }
  },
  methods: {
    edit(id,text){
      this.text = text
      this.id_item = id
      this.is_update = true
    },
    reset(){
      this.is_update=false
      this.text = ''

    },
    update(id){
      if (!this.text){
        toast.error('جملات اجباری است!')
        return;
      }
      fetch(`${this.base_url}/HamelQuestionnaire/update/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'text': this.text,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              toast.success(response.message)
              this.text = ''
              this.all()
              this.reset()
            }


          }).catch((err) => {
      })
    },
    deleteMethod(id){
      this.id_item = id
      this.deleteModal = true

    },
    submit_delete(id){
      fetch(`${this.base_url}/HamelQuestionnaire/destroy/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'text': this.text,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              toast.success(response.message)
              this.text = ''
              this.deleteModal = false
              this.all()
              this.reset()
            }


          }).catch((err) => {
      })
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    getName() {
      if (parseInt(this.id_route) === 1) this.name_route = 'علت یا فلسفه وجودی';
      else if (parseInt(this.id_route) === 2) this.name_route = 'زمینه فعالیت محصول (کالا یا خدمت)';
      else if (parseInt(this.id_route) === 3) this.name_route = 'مشتری';
      else if (parseInt(this.id_route) === 4) this.name_route = 'بازار';
      else if (parseInt(this.id_route) === 5) this.name_route = 'بقاء، رشد و سودآوری';
      else if (parseInt(this.id_route) === 6) this.name_route = 'مزیت رقابتی با ویژگی متمایز';
      else if (parseInt(this.id_route) === 7) this.name_route = 'فن آوری';
      else if (parseInt(this.id_route) === 8) this.name_route = 'تصور مردم';
      else if (parseInt(this.id_route) === 9) this.name_route = 'کارکنان';
      else if (parseInt(this.id_route) === 10) this.name_route = 'ماموریت بالادستی';
      else if (parseInt(this.id_route) === 11) this.name_route = 'عوامل کلیدی مستمر';
      else if (parseInt(this.id_route) === 12) this.name_route = 'الزامات محیطی';
      else if (parseInt(this.id_route) === 13) this.name_route = 'الزامات داخلی';
    },

    previousPage() {

      let num = parseInt(this.id_route) - 1
      if (num === 0) {
        router.push('/Vision_working_group_Suggested_perspective')

        return
      }
      router.push(`/Vision_working_group_Gary_Hamel_questionnaire/ByType/${num}`)
      this.id_route = num
      this.getName()
      this.all()
    },
    nextPage() {
      let num = parseInt(this.id_route) + 1
      if (num === 14) {
        router.push('/Vision_working_group_future/ByType/1')
        return
      }
      router.push(`/Vision_working_group_Gary_Hamel_questionnaire/ByType/${num}`)
      this.id_route = num
      this.getName()
      this.all()

    },
    all() {
      fetch(`${this.base_url}/HamelQuestionnaire`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.id_route,
        }),
      })
          .then(response => response.json())
          .then((response) => {

            this.all_items.length=0
            this.all_items = [...response.data]


          }).catch((err) => {
      })
    },
    store() {
      if (!this.text){
        toast.error('جملات اجباری است!')
        return;
      }
      fetch(`${this.base_url}/HamelQuestionnaire/store`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.id_route,
          'text': this.text,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.message) {
              toast.success(response.message)
              this.text = ''
              this.all()
            }


          }).catch((err) => {
      })
    }
  },
  mounted() {
    this.checkIsMother()
    this.getName()
    this.all()

  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small {
  font-size: 1vw !important;
}

textarea {
  height: 6vw !important;
}
</style>